const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const generateTerminalId = () => crypto.randomUUID();

export const isValidTerminalId = (value) =>
  typeof value === "string" && UUID_REGEX.test(value);

export const ensureTerminalIds = (terminals = []) =>
  terminals.map((terminal) => ({
    ...terminal,
    terminalID: terminal.terminalID || generateTerminalId(),
  }));
